/* tslint:disable */
/* eslint-disable */
/**
 * Client Signup API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const CompanySizeRequest = {
    Individual: 'INDIVIDUAL',
    Between2And10: 'BETWEEN_2_AND_10',
    Between11And49: 'BETWEEN_11_AND_49',
    Between50And249: 'BETWEEN_50_AND_249',
    Between250And999: 'BETWEEN_250_AND_999',
    Between1000And4999: 'BETWEEN_1000_AND_4999',
    MoreThan5000: 'MORE_THAN_5000'
} as const;
export type CompanySizeRequest = typeof CompanySizeRequest[keyof typeof CompanySizeRequest];


export function instanceOfCompanySizeRequest(value: any): boolean {
    for (const key in CompanySizeRequest) {
        if (Object.prototype.hasOwnProperty.call(CompanySizeRequest, key)) {
            // @ts-ignore
            if (CompanySizeRequest[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function CompanySizeRequestFromJSON(json: any): CompanySizeRequest {
    return CompanySizeRequestFromJSONTyped(json, false);
}

export function CompanySizeRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompanySizeRequest {
    return json as CompanySizeRequest;
}

export function CompanySizeRequestToJSON(value?: CompanySizeRequest | null): any {
    return value as any;
}

